import { Component, OnInit } from '@angular/core';
import { Cell, Product, ProductBase, ProductExtra } from '@nousmedis/cc-types';
import { CellService } from 'app/modules/catalog-cloud/services/cell.service';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PageService } from 'app/modules/catalog-cloud/services/page.service';


@Component({
  selector: 'app-cc-cell-detail-dialog',
  templateUrl: './cc-cell-detail-dialog.component.html',
  styleUrls: ['./cc-cell-detail-dialog.component.scss'],
})
export class CcCellDetailDialogComponent implements OnInit {
  item: ProductBase;
  product: Product;
  pageCell: Cell;
  idCatalog: string;
  idFascicle: string;
  idPage: string;
  idCellPage: string;

  selectedModel: string = '';
  models: string[] = [];
  extraFields: ProductExtra[] = [];
  notes: string = '';

  saving = false;

  constructor(
    private dialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig,
    private cellService: CellService,
    private msgService: MessageService,
    private pageService: PageService,
  ) {}

  ngOnInit(): void {
    const d = this.dialogConfig.data;
    this.item = d.item;
    this.product = d.product;
    this.pageCell = { ...d.pageCell };
    this.idCatalog = d.idCatalog;
    this.idFascicle = d.idFascicle;
    this.idPage = d.idPage;
    this.idCellPage = d.idCellPage;
    this.selectedModel = d.currentModel || '';
    this.notes = d.pageCell.notes || '';

    if (this.item.modelos) {
      this.models = typeof this.item.modelos === 'string'
        ? this.item.modelos.split(',').map((m: string) => m.trim()).filter(Boolean)
        : [];
    }

    const currentExtra: ProductExtra[] = d.currentExtra || [];
    this.extraFields = (
      currentExtra.length > 0
        ? currentExtra
        : Object.entries(this.item.extraFields || {}).map(([key, value]) => ({
            label: key,
            name: key,
            value: value as string,
          }))
    ).filter((f) => !['STATUS', 'category_parent', 'parent_category', 'estatus'].includes(f.label));
  }

  deleteNote(): void {
    this.notes = '';
    this.save();
  }

  save(): void {
    this.saving = true;
    this.pageService.takeSnapshot('cell_update');
    this.pageCell.productModel = this.selectedModel;
    this.pageCell.productExtra = this.extraFields;
    this.pageCell.notes = this.notes;

    this.cellService
      .update(this.idCatalog, this.idFascicle, this.idPage, this.idCellPage, this.pageCell)
      .subscribe({
        next: () => {
          this.updateMemory();
          this.pageService.reloadGrid$.next(true);
          this.msgService.add({ key: 'root-msg', detail: 'Celda actualizada', severity: 'success' });
          this.dialogRef.close({
            model: this.selectedModel,
            extraFields: this.extraFields,
            notes: this.notes,
            pageCell: this.pageCell,
          });
        },
        error: () => {
          this.saving = false;
          this.msgService.add({ key: 'root-msg', detail: 'Error al guardar', severity: 'error' });
        },
      });
  }

  private updateMemory(): void {
    const page = this.pageService.pages.find((p: any) => p.id === this.idPage);
    if (!page) return;
    const cell = page.cells.find((c: any) => c.id === this.idCellPage);
    if (!cell) return;
    cell.notes = this.notes;
    cell.productModel = this.selectedModel;
    cell.productExtra = this.extraFields;
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
